import { createSlice } from '@reduxjs/toolkit'

export const PageLoader = createSlice({
  name: 'PageLoader',
  initialState: {
    status: false,
  },
  reducers: {
    setPageLoading: (state, action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.status = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { setPageLoading } = PageLoader.actions

export default PageLoader.reducer
